import React, { useState } from 'react';
import axios from 'axios';
import './App.css';
import logo from './logo.png'; // Importiere das Logo

function App() {
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [walletId, setWalletId] = useState('');
    const [loraUrl, setLoraUrl] = useState('');
    const [step, setStep] = useState(1);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [generating, setGenerating] = useState(false);

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            const response = await axios.post('https://www.algobar.de/api/send-verification', { email });
            setMessage(response.data.message);
            setStep(2);
        } catch (err) {
            setError(err.response?.data?.error || 'Fehler beim Senden der E-Mail');
        }
    };

    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            const response = await axios.post('https://www.algobar.de/api/verify-code', { email, code });
            setMessage(response.data.message);
            setStep(3);
        } catch (err) {
            setError(err.response?.data?.error || 'Fehler bei der Verifizierung');
        }
    };

    const handleWalletSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setGenerating(true);
        try {
            const response = await axios.post('https://www.algobar.de/api/submit-wallet', { email, walletId });
            setMessage(response.data.message);
            setLoraUrl(response.data.loraUrl);
            setStep(4);
        } catch (err) {
            setError(err.response?.data?.error || 'Fehler beim Einreichen der Wallet-ID');
        } finally {
            console.log('Setze generating auf false'); // Debugging
            setGenerating(false);
        }
    };

    return (
        <div className="App">
            <div className="logo-container">
                <img src={logo} alt="AlgoBar Logo" className="logo" />
                <div className="liquid"></div> {/* Flüssigkeitselement */}
            </div>
            {step === 1 && (
                <form onSubmit={handleEmailSubmit}>
                    <div>
                        <label>E-Mail-Adresse:</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Deine E-Mail-Adresse"
                            required
                        />
                    </div>
                    <button type="submit">Code anfordern</button>
                </form>
            )}
            {step === 2 && (
                <form onSubmit={handleCodeSubmit}>
                    <div>
                        <label>Verifikationscode: </label>
                        <input
                            type="text"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="6-stelliger Code"
                            required
                        />
                    </div>
                    <button type="submit">Code verifizieren</button>
                </form>
            )}
            {step === 3 && (
                <div className="success-container">
                    <p className="success-message">Verifizierung erfolgreich! Bitte gib deine Wallet-ID ein:</p>
                    <form onSubmit={handleWalletSubmit}>
                        <div>
                            <label>Wallet-ID:</label>
                            <input
                                type="text"
                                value={walletId}
                                onChange={(e) => setWalletId(e.target.value)}
                                placeholder="Deine Algorand Wallet-Adresse"
                                required
                            />
                        </div>
                        <button type="submit" disabled={generating} className={generating ? 'disabled' : ''}>
                            {generating ? 'Generiere Partizipationsschlüssel...' : 'Wallet-ID einreichen'}
                        </button>
                    </form>
                    {generating && (
                        <div className="loading-container">
                            <div className="spinner"></div>
                            <p style={{ color: '#00f7ff' }}>
                                Die Generierung der Partizipationsschlüssel kann einige Minuten dauern. Bitte habe Geduld...
                            </p>
                        </div>
                    )}
                </div>
            )}
            {step === 4 && (
                <div className="success-container">
                    <p className="success-message">{message}</p>
                    {loraUrl && (
                        <p>
                            <a href={loraUrl} target="_blank" rel="noopener noreferrer">Zu AlgoKit Lora</a>
                        </p>
                    )}
                </div>
            )}
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {message && step < 3 && <p style={{ color: 'green' }}>{message}</p>}
        </div>
    );
}

export default App;
